module.exports = __webpack_public_path__ + "img/benefit-title-mobile.9fb2f7ec.png";